import PlayButton from '../util/play_button'

up.compiler('[video-slide]', (element) => {

  const video = element.querySelector('video')
  const playButton = element.querySelector('[video-slide--play-button]')

  const videoPlayButton = new PlayButton(video, playButton)
  videoPlayButton.connect()

  return () => {
    videoPlayButton.disconnect()
  }

})
